import { PhCheckCircle, PhWarningCircle } from 'ember-phosphor-icons';
import type { TOC } from '@ember/component/template-only';

interface PslfDashboardTodoIndexSignature {
  Args: {
    isComplete: boolean;
    title: string;
  };
  Blocks: {
    actions: [];
    body: [];
    footer: [];
    leftHeader: [];
  };
  Element: HTMLLIElement;
}

const PslfDashboardTodoIndexComponent: TOC<PslfDashboardTodoIndexSignature> = <template>
  <div class="tio-row-flush leading-none">
    <div>
      {{yield to="leftHeader"}}
    </div>
    <div class="grow text-left font-semibold text-lg">{{@title}}</div>
    {{#if @isComplete}}
      <PhCheckCircle @size="24" @weight="fill" class="text-mint-300" />
    {{else}}
      <PhWarningCircle @size="24" @weight="fill" class="text-error-400" />
    {{/if}}
  </div>
  <div class="pt-2 pb-3 mx-2 text-center tio-flex-center">
    {{yield to="body"}}
  </div>
  <div class="mx-auto grid grid-cols-1 gap-2 max-w-72">
    {{yield to="actions"}}
  </div>
  <div class="mx-auto grid grid-cols-1 gap-2">
    {{yield to="footer"}}
  </div>
</template>;

export default PslfDashboardTodoIndexComponent;
